import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { EntryContext } from '../contexts/entryContext';
import axios from 'axios';

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const useLogger = (errorCode) => {
    const { credentials, game, entry } = useContext(EntryContext);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [error, setError] = useState(false);
    const query = useQuery();

    useEffect(() => {
        const fetchLoggerUrl = async () => {
            const anomalyCode = errorCode?.startsWith('ERROR_') ? errorCode.slice(6) : errorCode;
            const payload = {
                code: anomalyCode,
                category: 'generic',
                severity: 'error',
                errorCode: errorCode,
                dataQueryParameter: query.get('data'),
                jurisdiction: credentials?.jurisdiction,
                game_id: game?.game_id ?? null,
                entry: entry?.ticketData ? entry : null,
            };

            if (!errorCode) {
                setLoading(false);
                console.error('🔴 Missing error code.', payload);
                setError({ message: 'Missing error code.', payload });
                return;
            }

            try {
                setLoading(true);
                //? For debug: console.log('🔵 Sending error log to API with payload:', payload);
                const response = await axios.post(`/api/anomaly`, payload);

                //? For debug: console.log('🔵 API response from Logger:', JSON.stringify(response?.data || {}), response);
                setSuccess(response);
                setError(false);
            } catch (error) {
                console.error('🔴 API when hitting api/anomaly', error);
                setError(error);
            } finally {
                setCompleted(true);
                setLoading(false);
            }
        };

        if (errorCode && !completed) {
            fetchLoggerUrl();
        }
    }, [errorCode, completed, credentials?.jurisdiction, game?.game_id]);

    return { success, error, loading, completed };
};

export default useLogger;
